'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdReplyAll = function MdReplyAll(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 15c11.7 1.6 16.8 10 18.4 18.4-4.1-5.9-10-8.6-18.4-8.6v6.8l-11.6-11.6 11.6-11.6v6.6z m-10-1.6l-6.6 6.6 6.6 6.6v5l-11.6-11.6 11.6-11.6v5z' })
        )
    );
};

exports.default = MdReplyAll;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/reply-all.js
// module id = 3717
// module chunks = 168707334958949